import axios from 'axios'
import library from '../../../utils/Library'

export const restoreInternalRecycleBin = async (ids) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('storage') + '/internalrecyclebin/restore'

  return await axios({
    url: URL,
    method: 'POST',
    data: {
      documentIds: ids
    },
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
